(function () {
    'use strict';
    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('bank',
                {
                    url: '/:langcode/bank',
                    templateUrl: 'app/bank/bank.html',
                    controller: 'BankController',

                    params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'bank');
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("bank");
                            return $translate.refresh();
                        }],
                        title: ['$translate', function ($translate) {
                            return $translate('intro_screen').then(function (res) {
                                return res;
                            });
                        }],
                        redirect: ['auth_factory', '$rootScope', '$transition$', '$q', 'userSvc', function (auth_factory, $rootScope, $transition$, $q, userSvc) {
                            var deferred = $q.defer();
                            if ($rootScope.isTop) {
                                var utmSource = window.getUrlParameter('utm_source');
                                var token = null;

                                if (window.hasAllowance === 'bank') {
                                    $rootScope.isBank = true;
                                    // Set source based on bank: isbankasi=5, yapikredi=4, akbank=12
                                    var bankSource = null;
                                    if (utmSource === 'isbankasi') {
                                        bankSource = 5;
                                    } else if (utmSource === 'yapikredi') {
                                        bankSource = 4;
                                        token = window.getUrlParameter('authorizationCode');
                                    } else if (utmSource === 'akbank') {
                                        bankSource = 12;
                                        token = window.getUrlParameter('id');
                                    }
                                    $rootScope.clientData = {
                                        name: null,
                                        surName: null,
                                        phoneNumber: null,
                                        email: null,
                                        ip: null,
                                        source: bankSource
                                    };
                                    userSvc.getUserInfo(null, true).then(function (res) {
                                        if (utmSource === 'yapikredi') {
                                            //var sessionToken = window.getUrlParameter('authorizationCode') ? window.getUrlParameter('authorizationCode') : "PSPTACE4815BA73B45EAA9EB1CA223872EDA";

                                            auth_factory.getBankUserDetails({ token: token }).$promise.then(function (response) {
                                                $rootScope.clientData = Object.assign($rootScope.clientData, {
                                                    name: response.Name,
                                                    surName: response.Surname,
                                                    phoneNumber: response.PhoneNumber,
                                                    email: response.Email,
                                                    source: 4
                                                });
                                                $rootScope.yapiKrediSessionToken = response.SessionToken;

                                            }).finally(() => {
                                                $transition$.abort();
                                                deferred.resolve($transition$.router.stateService.go('analysis.country.portfolio', { langcode: window.lang, country: $rootScope.country }));
                                            });
                                        } else {
                                            $transition$.abort();
                                            deferred.resolve($transition$.router.stateService.go('analysis.country.portfolio', { langcode: window.lang, country: $rootScope.country }));
                                            return deferred.promise;
                                        }

                                    }, function () {
                                        if (utmSource === 'isbankasi') {
                                            function postAppMessage(msg) {
                                                if (window.webkit != undefined) {
                                                    if (window.webkit.messageHandlers.miniapp != undefined) {
                                                        window.webkit.messageHandlers.miniapp.postMessage(msg);
                                                    }
                                                }
                                                else if (window.miniapp != undefined) {
                                                    window.miniapp.postMessage(msg);
                                                } else {
                                                    console.log('window.webkit and window.miniapp not defined!');
                                                }
                                                deferred.resolve();
                                            }

                                            function getClientInfo(fName) {
                                                try {
                                                    let message = {
                                                        "callFunction": {
                                                            "functionName": fName,
                                                            "param": {/*
                                                                            "paramA" : 123,
                                                                            "paramB" : 234,
                                                                            "paramC" : "str"*/
                                                            },
                                                            // "callback": "functionCallback"
                                                        }
                                                    };
                                                    postAppMessage(JSON.stringify(message));
                                                } catch (err) {
                                                    console.log('Error occurred calling native method');
                                                    deferred.reject();
                                                }

                                            }

                                            window.functionCallback = function (functionName, result) {
                                                /*
                                                {   "isSuccess": true,
                                                    "retVal": { "funcRetVal": {"ClientIp" : "127.0.0.1"},
                                                                "consentName" : "GetClientIp",
                                                                "isApproved" : true
                                                            }
                                                }
                                                */
                                                try {
                                                    let parsedResult = JSON.parse(result);
                                                    if (parsedResult.isSuccess && parsedResult.retVal.isApproved) {
                                                        if (parsedResult.retVal.funcRetVal.ClientIp)
                                                            $rootScope.clientData.ip = parsedResult.retVal.funcRetVal.ClientIp;

                                                        if (parsedResult.retVal.funcRetVal.Email)
                                                            $rootScope.clientData.email = parsedResult.retVal.funcRetVal.Email;

                                                        if (parsedResult.retVal.funcRetVal.PhoneNumber)
                                                            $rootScope.clientData.phoneNumber = parsedResult.retVal.funcRetVal.PhoneNumber;

                                                        if (parsedResult.retVal.funcRetVal.Name)
                                                            $rootScope.clientData.name = parsedResult.retVal.funcRetVal.Name;
                                                        if (parsedResult.retVal.funcRetVal.Name)
                                                            $rootScope.clientData.name = parsedResult.retVal.funcRetVal.Name;

                                                        if (parsedResult.retVal.funcRetVal.Surname)
                                                            $rootScope.clientData.surName = parsedResult.retVal.funcRetVal.Surname;
                                                    }
                                                    if ($rootScope.clientData.phoneNumber && $rootScope.clientData.name && $rootScope.clientData.surName) {
                                                        $rootScope.clientData.source = 5;
                                                        if (window.localStorage.getItem('first_visit'))
                                                            $transition$.router.stateService.go('valuation-wrapper', { langcode: window.lang });
                                                    }
                                                } catch (error) {
                                                    console.error("JSON verisi işlenirken bir hata oluştu:", error);
                                                    deferred.reject();
                                                }
                                            };

                                            // getClientInfo('GetClientIP');
                                            // getClientInfo('GetMailAddress');
                                            getClientInfo('GetPhoneNumber');
                                            getClientInfo('GetIdentity');

                                        } else if (utmSource === 'yapikredi' || utmSource === 'akbank') {
                                            //var sessionToken = window.getUrlParameter('authorizationCode') ? window.getUrlParameter('authorizationCode') : "PSPTACE4815BA73B45EAA9EB1CA223872EDA";

                                            auth_factory.getBankUserDetails({ token: token }).$promise.then(function (response) {
                                                $rootScope.clientData = Object.assign($rootScope.clientData, {
                                                    name: response.Name,
                                                    surName: response.Surname,
                                                    phoneNumber: response.PhoneNumber,
                                                    email: response.Email,
                                                    source: utmSource === 'yapikredi' ? 4 : 12
                                                });
                                                if (utmSource === 'yapikredi') {
                                                    $rootScope.yapiKrediSessionToken = response.SessionToken;
                                                }

                                            }).finally(() => {
                                                if (!window.localStorage.getItem('first_visit')) {
                                                    deferred.resolve();
                                                } else {
                                                    deferred.resolve($transition$.router.stateService.go('valuation-wrapper', { langcode: window.lang }, { reload: true }));
                                                }
                                            });
                                        }
                                    });
                                }
                            }
                            return deferred.promise;
                        }]
                    },
                    metaTags: {
                        title: '{{title}}',
                        robots: 'noindex, nofollow',
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    }
                });
    }]);

})();
